<template>
  <div>
    <b-loading :active.sync="isLoadingPage"></b-loading>
    <div
      v-if="tabPage === 'list'"
      class="has-text-centered pd-y-1 disable-print"
      :class="maxWidth > 768 ? 'pd-y-1' : 'pd-y-3'"
    >
      <b-button
        @click="goToDetail(), (isViewComponent = false)"
        :style="styleObject"
        size="is-medium"
        icon-pack="fas"
        icon-left="plus"
        >เพิ่มรายการ</b-button
      >
    </div>
    <div v-if="tabPage === 'detail'" class="disable-print">
      <a @click="backPage" class="is-size-7" v-if="decode == null">
        <b-icon
          icon="arrow-left"
          class="mg-less text-black"
          size="is-small"
        ></b-icon>
        <span class="text-black">กลับไปหน้า</span>
        {{ wordBack }}
      </a>
      <p class="is-size-6 has-text-right mg-t-3" v-if="decode == null">
        <span class="has-text-weight-semibold">แก้ไขล่าสุดเมื่อ:</span>
        {{ updateDateForm | dateTimeTh }}
      </p>
      <div>
        <div
          class="menuMobile is-hidden-tablet"
          v-if="renderFormAside === true"
        >
          <i
            v-show="menuActive == false"
            @click="menuActive = !menuActive"
            class="fas fa-bars"
          ></i>
          <i
            v-show="menuActive == true"
            @click="menuActive = !menuActive"
            class="fas fa-times"
          ></i>
        </div>
        <div class="columns is-marginless">
          <div class="column is-5 box-step pd-5">
            <div
              :class="[
                maxWidth > 768 ? '' : 'mobileSide',
                menuActive ? '' : 'active',
              ]"
            >
              <div class="has-text-left">
                <aside v-if="renderFormAside === true" class="menu width-max">
                  <ul
                    class="menu-list ls-none"
                    v-for="(component, index) in forms.components"
                    :key="index"
                  >
                    <li>
                      <b-collapse :aria-id="component.key">
                        <a
                          @click="setFormComponent(component, index)"
                          href="#"
                          v-scroll-to="'#M' + component.key"
                          :class="
                            asideMenu === component.key
                              ? 'text-success-form'
                              : ''
                          "
                          slot="trigger"
                          slot-scope="props"
                          class="text-break-all is-flex ai-center pd-less"
                          :id="index === 0 ? 'form-select-title' : null"
                          :title="component.componentName"
                        >
                          <span class="is-flex ai-center">
                            <b-icon
                              :class="{
                                'is-hidden position-absolute':
                                  component.children.length === 0 ||
                                  props.open === true,
                              }"
                              pack="fas"
                              size="is-small"
                              icon="plus-circle"
                              class="has-text-grey-light is-size-7"
                            ></b-icon>
                            <b-icon
                              :class="{
                                'is-hidden position-absolute':
                                  component.children.length === 0 ||
                                  props.open === false,
                              }"
                              pack="fas"
                              size="is-small"
                              icon="minus-circle"
                              class="has-text-grey-light is-size-7"
                            ></b-icon>
                            <span
                              class="is-size-4 subMenu has-text-weight-normal pd-x-5 is-multiline"
                              >{{ component.componentName }}</span
                            >
                            <span
                              v-if="component.children.length !== 0"
                              class="pd-x-5 is-size-4 word-break-keep-all"
                              :class="{
                                'text-success-form':
                                  getCompelete(component.key) === true,
                              }"
                              >{{ getCompeleteStep(component.children) }}/{{
                                component.children.length
                              }}</span
                            >
                            <b-icon
                              v-if="getCompelete(component.key) === true"
                              pack="fas"
                              size="is-small"
                              icon="check-circle"
                              class="text-success-form"
                            ></b-icon>
                          </span>
                        </a>
                        <ul
                          :aria-controls="component.componentName + '' + index"
                          class="is-paddingless"
                        >
                          <FormSubTab
                            :components="component.children"
                            :asideMenu="asideMenu"
                            :getCompelete="getCompelete"
                            :getCompeleteStep="getCompeleteStep"
                            :hiddenCompelete="false"
                            :indexMain="index"
                            @setFormComponent="setFormComponent"
                          />
                        </ul>
                      </b-collapse>
                    </li>
                  </ul>
                </aside>
              </div>
            </div>
          </div>
          <div class="column is-7 pd-20 has-text-left">
            <div v-if="isViewComponent">
              <div class="mg-t-15">
                <FormInput
                  v-if="renderForm === true"
                  :propsComponentForm="formsChildren"
                  :depth="0"
                  :validPorps="inputValidate"
                  :formType="forms.type"
                  :inputValue="inputValue"
                  :compeleteKey="compeleteKey"
                  :compeleteFormData="compeleteFormData"
                  :formId="forms._id"
                  :checkVarDes="checkVarDes"
                  :checkModelValue="checkModelValue"
                  @setRenderComponent="setRenderComponent"
                  @fetchDataForm="fetchDataForm"
                  :setMatchId="setMatchId"
                  :delInput="delInput"
                  :matchId="matchId"
                  :inputFormData="inputFormData"
                  :addInput="addInput"
                  :addForm="addForm"
                  :delForm="delForm"
                  :inputFormComponent="inputFormComponent"
                  :dataKpi="dataKpi"
                  :dataInputKpi="dataInputKpi"
                  :formUserId="formUserId"
                  :demo="demo"
                  formAction="view"
                  :routerData="routerData"
                  :dataFormInputAll="dataFormInputAll"
                  :ownedId="ownedId"
                  @setFormUserId="setFormUserId"
                  :formsName="forms.name"
                  @backPage="backPage"
                />
              </div>
            </div>
            <div v-else>
              <div class="mg-t-15">
                <FormInput
                  v-if="renderForm === true"
                  :propsComponentForm="formsChildren"
                  :depth="0"
                  :validPorps="inputValidate"
                  :formType="forms.type"
                  :inputValue="inputValue"
                  :compeleteKey="compeleteKey"
                  :compeleteFormData="compeleteFormData"
                  :formId="forms._id"
                  :checkVarDes="checkVarDes"
                  :checkModelValue="checkModelValue"
                  @setRenderComponent="setRenderComponent"
                  @fetchDataForm="fetchDataForm"
                  :setMatchId="setMatchId"
                  :delInput="delInput"
                  :matchId="matchId"
                  :inputFormData="inputFormData"
                  :addInput="addInput"
                  :addForm="addForm"
                  :delForm="delForm"
                  :inputFormComponent="inputFormComponent"
                  :dataKpi="dataKpi"
                  :dataInputKpi="dataInputKpi"
                  :formUserId="formUserId"
                  :demo="demo"
                  formAction="edit"
                  :routerData="routerData"
                  :dataFormInputAll="dataFormInputAll"
                  :ownedId="ownedId"
                  @setFormUserId="setFormUserId"
                  :formsName="forms.name"
                  @backPage="backPage"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="tabPage === 'list'">
      <b-tabs
        v-model="activeTab"
        v-if="tab === true"
        size="is-medium"
        class="disable-print tab-custom-actions"
        @change="changTap()"
      >
        <div
          class="actions is-flex ai-center"
          :class="maxWidth > 768 ? '' : 'js-between'"
        >
          <a @click="backPage" class="is-size-7 mg-r-3"  v-if="decode == null">
            <b-icon
              icon="arrow-left"
              class="mg-less text-black"
              size="is-small"
            ></b-icon>
            <span class="text-black">กลับไปหน้า</span>
            {{ wordBack }}
          </a>
          <b-dropdown
            aria-role="list"
            position="is-bottom-left"
            v-if="activeTab !== 2"
          >
            <button
              :style="styleObject"
              class="button is-primary"
              slot="trigger"
              slot-scope="{ active }"
            >
              <span> <i class="fas fa-filter"></i> ค้นหา </span>
            </button>
            <b-dropdown-item custom>
              <div
                class="modal-card is-marginless"
                :style="maxWidth > 768 ? 'width: 400px' : 'width:100%'"
              >
                <section class="modal-card-body">
                  <h2 class="is-flex js-between ai-center">
                    <span> <i class="fas fa-filter"></i> ค้นหา </span>
                    <i
                      class="fas fa-broom fa-sm cr-pointer"
                      @click="resetfilter"
                    ></i>
                  </h2>
                  <hr />
                  <b-field
                    :label="data.title"
                    v-for="(data, index) in labelColumn"
                    :key="index"
                  >
                    <input class="input w-100" :ref="data.name" type="search" />
                  </b-field>
                  <div class="has-text-centered">
                    <button
                      :style="styleObject"
                      class="button"
                      @click="(dataFilter.page = 1), setDataFilter(activeTab)"
                    >
                      ค้นหา
                    </button>
                  </div>
                </section>
              </div>
            </b-dropdown-item>
          </b-dropdown>
        </div>
        <b-tab-item
          :label="
            'รายการ (' + dataLimit.length + '/' + formDataList.length + ')'
          "
          class="disable-print"
        >
          <div v-if="tabPage === 'list'">
            <FormCompanyList
              :column="labelColumn"
              :data="dataLimit"
              :formDataListConst="formDataListConst"
              :currentSortDir="currentSortDir"
              :currentSort="currentSort"
              @goToDetail="goToDetail"
              @setViewComponent="setViewComponent"
              @viewMoreform="viewMoreform"
              @fetchDataForm="fetchDataForm"
            />

            <b-pagination
              :total="formDataList.length"
              :current.sync="dataFilter.page"
              range-before="1"
              range-after="1"
              :order="'is-centered'"
              :size="'is-small'"
              :simple="false"
              :rounded="false"
              :per-page="dataFilter.limit"
            >
              <b-pagination-button
                slot-scope="props"
                :page="props.page"
                tag="router-link"
                :to="setUrl(props.page.number)"
                >{{ props.page.number }}</b-pagination-button
              >

              <b-pagination-button
                slot="previous"
                slot-scope="props"
                :page="props.page"
                tag="router-link"
                :to="setUrl(props.page.number)"
              >
                <i class="fas fa-chevron-left"></i>
              </b-pagination-button>

              <b-pagination-button
                slot="next"
                slot-scope="props"
                :page="props.page"
                tag="router-link"
                :to="setUrl(Number(dataFilter.page) + 1)"
              >
                <i class="fas fa-chevron-right"></i>
              </b-pagination-button>
            </b-pagination>
          </div>
        </b-tab-item>
        <b-tab-item label="รายงาน">
          <FormReport
            v-if="randerCumponentReport === true"
            :valueConst="formDataList"
            :tableDataValue="dataLimit"
            :tiltleTableFormReport="tiltleTableFormReport"
            class="mg-b-3"
            :ownedId="ownedId"
          />

          <b-pagination
            :total="formDataList.length"
            :current.sync="dataFilter.page"
            range-before="1"
            range-after="1"
            :order="'is-centered'"
            :size="'is-small'"
            :simple="false"
            :rounded="false"
            :per-page="dataFilter.limit"
          >
            <b-pagination-button
              slot-scope="props"
              :page="props.page"
              tag="router-link"
              :to="setUrl(props.page.number)"
              >{{ props.page.number }}</b-pagination-button
            >

            <b-pagination-button
              slot="previous"
              slot-scope="props"
              :page="props.page"
              tag="router-link"
              :to="setUrl(props.page.number)"
            >
              <i class="fas fa-chevron-left"></i>
            </b-pagination-button>

            <b-pagination-button
              slot="next"
              slot-scope="props"
              :page="props.page"
              tag="router-link"
              :to="setUrl(Number(dataFilter.page) + 1)"
            >
              <i class="fas fa-chevron-right"></i>
            </b-pagination-button>
          </b-pagination>
        </b-tab-item>
        <b-tab-item label="สรุปข้อมูล">
          <div
            v-if="Object.values(forms).length === 0"
            class="is-detail-list detail-table mg-y-15"
          >
            <p
              class="has-text-drak is-size-4 th column is-padding-x-s is-margin-top-s has-text-centered"
            ></p>
            <p
              class="has-text-drak is-size-6 th column is-padding-x has-text-centered has-text-centered"
            >
              *** ขณะนี้ยังไม่มีข้อมูล Form ***
            </p>
            <p
              class="has-text-drak is-size-4 th column is-padding-x-s is-margin-top-s has-text-centered"
            ></p>
          </div>
          <div v-else class="has-background-white pd-20 is-radius">
            <div class="columns is-marginless">
              <div class="column is-5 box-step pd-5">
                <div>
                  <div class="has-text-left">
                    <aside
                      v-if="renderFormAside === true"
                      class="menu width-max"
                    >
                      <ul
                        class="menu-list ls-none"
                        v-for="(component, index) in forms.components"
                        :key="index"
                      >
                        <li>
                          <b-collapse :aria-id="component.key">
                            <a
                              @click="setFormComponent(component, index)"
                              href="#"
                              v-scroll-to="'#M' + component.key"
                              :class="
                                asideMenu === component.key
                                  ? 'text-success-form'
                                  : ''
                              "
                              slot="trigger"
                              slot-scope="props"
                              class="text-break-all is-flex ai-center pd-less"
                              :id="index === 0 ? 'form-select-title' : null"
                              :title="component.componentName"
                            >
                              <span class="is-contents">
                                <b-icon
                                  :class="{
                                    'is-hidden position-absolute':
                                      component.children.length === 0 ||
                                      props.open === true,
                                  }"
                                  pack="fas"
                                  size="is-small"
                                  icon="plus-circle"
                                  class="has-text-grey-light is-size-7"
                                ></b-icon>
                                <b-icon
                                  :class="{
                                    'is-hidden position-absolute':
                                      component.children.length === 0 ||
                                      props.open === false,
                                  }"
                                  pack="fas"
                                  size="is-small"
                                  icon="minus-circle"
                                  class="has-text-grey-light is-size-7"
                                ></b-icon>
                                <span
                                  class="is-size-4 subMenu has-text-weight-normal pd-x-5 is-multiline"
                                  >{{ component.componentName }}</span
                                >
                                <span
                                  v-if="component.children.length !== 0"
                                  class="pd-x-5 is-size-4"
                                  :class="{
                                    'text-success-form':
                                      getCompelete(component.key) === true,
                                  }"
                                  >{{ getCompeleteStep(component.children) }}/{{
                                    component.children.length
                                  }}</span
                                >
                                <b-icon
                                  v-if="getCompelete(component.key) === true"
                                  pack="fas"
                                  size="is-small"
                                  icon="check-circle"
                                  class="text-success-form"
                                ></b-icon>
                              </span>
                            </a>
                            <ul
                              :aria-controls="
                                component.componentName + '' + index
                              "
                              class="is-paddingless"
                            >
                              <FormSubTab
                                :components="component.children"
                                :asideMenu="asideMenu"
                                :getCompelete="getCompelete"
                                :getCompeleteStep="getCompeleteStep"
                                :hiddenCompelete="false"
                                :indexMain="index"
                                @setFormComponent="setFormComponent"
                              />
                            </ul>
                          </b-collapse>
                        </li>
                      </ul>
                    </aside>
                  </div>
                </div>
              </div>
              <div class="column is-7 pd-20 has-text-left">
                <div class="mg-t-15" v-if="randerCumponentSum === true">
                  <FormInput
                    :propsComponentForm="formsChildren"
                    :depth="0"
                    :routerData="routerData"
                    :validPorps="inputValidate"
                    :formType="forms.type"
                    :inputValue="inputValue"
                    :compeleteKey="compeleteKey"
                    :compeleteFormData="compeleteFormData"
                    :formId="forms._id"
                    :checkVarDes="checkVarDes"
                    :checkModelValue="checkModelValue"
                    @setRenderComponent="setRenderComponent"
                    @fetchDataForm="fetchDataForm"
                    :setMatchId="setMatchId"
                    :delInput="delInput"
                    :matchId="matchId"
                    :inputFormData="inputFormData"
                    :addInput="addInput"
                    :addForm="addForm"
                    :delForm="delForm"
                    :inputFormComponent="inputFormComponent"
                    :dataKpi="dataKpi"
                    :dataInputKpi="dataInputKpi"
                    :demo="demo"
                    formAction="summary"
                    :dataFormInputAll="dataFormInputAll"
                    @setFormUserId="setFormUserId"
                    :formsName="forms.name"
                    @backPage="backPage"
                  />
                </div>
              </div>
            </div>
          </div>
        </b-tab-item>
      </b-tabs>

      <div v-else class="disable-print">
        <p v-if="demo === false && decode == null" class="is-size-6 has-text-right pd-b-15">
          <span class="has-text-weight-semibold">แก้ไขล่าสุดเมื่อ:</span>
          {{ updateDateForm | dateTimeTh }}
        </p>
        <div class="has-background-white pd-20 is-radius">
          <div class="columns is-marginless">
            <div class="column is-5 box-step pd-5">
              <div>
                <div class="has-text-left">
                  <aside
                    v-if="renderFormAside === true"
                    class="menu width-max"
                    id="form-title"
                  >
                    <ul
                      class="menu-list ls-none"
                      v-for="(component, index) in forms.components"
                      :key="index"
                    >
                      <li>
                        <b-collapse :aria-id="component.key">
                          <a
                            @click="setFormComponent(component, index)"
                            href="#"
                            v-scroll-to="'#M' + component.key"
                            :class="
                              asideMenu === component.key
                                ? 'text-success-form'
                                : ''
                            "
                            slot="trigger"
                            slot-scope="props"
                            class="th text-break-all is-flex ai-center is-paddingless"
                            :id="index === 0 ? 'form-select-title' : null"
                            :title="component.componentName"
                          >
                            <span class="is-contents">
                              <b-icon
                                :class="{
                                  'is-hidden position-absolute':
                                    component.children.length === 0 ||
                                    props.open === true,
                                }"
                                pack="fas"
                                size="is-small"
                                icon="plus-circle"
                                class="has-text-grey-light is-size-7"
                              ></b-icon>
                              <b-icon
                                :class="{
                                  'is-hidden position-absolute':
                                    component.children.length === 0 ||
                                    props.open === false,
                                }"
                                pack="fas"
                                size="is-small"
                                icon="minus-circle"
                                class="has-text-grey-light is-size-7"
                              ></b-icon>
                              <span
                                class="is-size-4 subMenu has-text-weight-normal pd-x-5 is-multiline"
                                >{{ component.componentName }}</span
                              >
                              <span
                                v-if="
                                  component.children.length !== 0 &&
                                  demo === false
                                "
                                class="pd-x-5 is-size-4"
                                :class="{
                                  'text-success-form':
                                    getCompelete(component.key) === true,
                                }"
                                >{{ getCompeleteStep(component.children) }}/{{
                                  component.children.length
                                }}</span
                              >
                              <b-icon
                                v-if="getCompelete(component.key) === true"
                                pack="fas"
                                size="is-small"
                                icon="check-circle"
                                class="text-success-form"
                              ></b-icon>
                            </span>
                          </a>
                          <ul
                            :aria-controls="
                              component.componentName + '' + index
                            "
                            class="is-paddingless"
                            :key="index"
                          >
                            <FormSubTab
                              :components="component.children"
                              :asideMenu="asideMenu"
                              :getCompelete="getCompelete"
                              :getCompeleteStep="getCompeleteStep"
                              :hiddenCompelete="demo === true ? true : false"
                              @setFormComponent="setFormComponent"
                              :indexMain="index"
                            />
                          </ul>
                        </b-collapse>
                      </li>
                    </ul>
                  </aside>
                </div>
              </div>
            </div>
            <div class="column is-7 pd-20 has-text-left">
              <div v-if="isLockForm === true">
                <FormInput
                  v-if="renderForm === true"
                  :propsComponentForm="formsChildren"
                  :depth="0"
                  :validPorps="inputValidate"
                  :formType="forms.type"
                  :inputValue="inputValue"
                  :compeleteKey="compeleteKey"
                  :compeleteFormData="compeleteFormData"
                  :formId="forms._id"
                  :checkVarDes="checkVarDes"
                  :checkModelValue="checkModelValue"
                  @setRenderComponent="setRenderComponent"
                  @fetchDataForm="fetchDataForm"
                  :setMatchId="setMatchId"
                  :delInput="delInput"
                  :matchId="matchId"
                  :inputFormData="inputFormData"
                  :addInput="addInput"
                  :addForm="addForm"
                  :delForm="delForm"
                  :inputFormComponent="inputFormComponent"
                  :dataKpi="dataKpi"
                  :routerData="routerData"
                  :dataInputKpi="dataInputKpi"
                  :formUserId="formUserId"
                  :demo="demo"
                  formAction="view"
                  :dataFormInputAll="dataFormInputAll"
                  :ownedId="ownedId"
                  @setFormUserId="setFormUserId"
                  :formsName="forms.name"
                  @backPage="backPage"
                />
              </div>
              <div v-else>
                <div class="mg-t-15" id="form-fill-input">
                  <FormInput
                    v-if="renderForm === true"
                    :propsComponentForm="formsChildren"
                    :depth="0"
                    :validPorps="inputValidate"
                    :formType="forms.type"
                    :inputValue="inputValue"
                    :compeleteKey="compeleteKey"
                    :compeleteFormData="compeleteFormData"
                    :formId="forms._id"
                    :checkVarDes="checkVarDes"
                    :checkModelValue="checkModelValue"
                    @setRenderComponent="setRenderComponent"
                    @fetchDataForm="fetchDataForm"
                    :setMatchId="setMatchId"
                    :delInput="delInput"
                    :matchId="matchId"
                    :inputFormData="inputFormData"
                    :addInput="addInput"
                    :addForm="addForm"
                    :delForm="delForm"
                    :inputFormComponent="inputFormComponent"
                    :dataKpi="dataKpi"
                    :dataInputKpi="dataInputKpi"
                    :formUserId="formUserId"
                    :demo="demo"
                    :routerData="routerData"
                    formAction="edit"
                    :dataFormInputAll="dataFormInputAll"
                    :ownedId="ownedId"
                    @setFormUserId="setFormUserId"
                    @backPage="backPage"
                    :formsName="forms.name"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="show-print">
      <div>
        <!-- <div v-if="Object.values(forms).length > 0" class="is-size-6 centeralignment">
                    <h2 :title="forms.name" class="th ">{{forms.name}}</h2>
        </div>-->
        <p class="pd-y-5 has-text-right is-size-6" >
          <span class="has-text-weight-normal">แก้ไขล่าสุดเมื่อ:</span>
          {{ updateDateForm | dateTimeTh }}
        </p>
      </div>
      <div class="has-background-white is-radius">
        <FormPrint
          v-if="renderForm === true"
          :propsComponentForm="forms.components"
          :depth="0"
          :inputValue="inputValue"
          :inputFormComponent="inputFormComponent"
        />
      </div>
    </div>

    <a
      v-if="tabPage === 'detail' && Object.values(dataFormInput).length > 0"
      class="iconPage viewEdit disable-print cr-pointer"
      @click="changePageView"
    >
      <i v-if="isViewComponent" class="fas fa-pen"></i>
      <i v-else class="fas fa-eye"></i>
    </a>

    <a
      v-if="printIcon && Object.values(dataFormInput).length > 0"
      class="iconPage print disable-print cr-pointer"
      @click="onPrint()"
    >
      <i class="fas fa-print"></i>
    </a>
  </div>
</template>

<script>
import { HTTP, HTTPDynamic } from "@/service/axios.js";
import FormSubTab from "./FormSubTab";
import FormInput from "./FormInput";
import FormCompanyList from "./FormCompanyList";
import FormSummaryData from "./FormSummaryData";
import FormReport from "./FormReport";
import FormPrint from "./FormPrint";
import momentTH from "moment/src/locale/th";
import moment from "moment";

export default {
  props: ["formId", "tab", "isLockForm", "demo", "routerData"],
  components: {
    FormSubTab,
    FormInput,
    FormCompanyList,
    FormSummaryData,
    FormReport,
    FormPrint,
  },
  data() {
    return {
      menuActive: false,
      baseUrl: process.env.VUE_APP_BASE_URL,
      forms: [],
      isLoadingPage: false,
      renderForm: false,
      renderFormAside: false,
      formsChildren: [],
      dataFormInput: {},
      inputValue: {},
      dataInputKpi: {},
      inputValidate: {},
      checkModelValue: {},
      checkVarDes: {},
      dataKpi: {},
      updateDateForm: null,
      asideMenu: null,
      compeleteKey: [],
      compeleteFormData: [],
      matchId: {},
      inputFormData: {},
      dataFormInputAdd: {},
      inputFormComponent: {},
      dataFormComponent: {},
      activeTab: 0,
      tiltleTableFormReport: [],
      isViewComponent: false,
      currentSort: "",
      currentSortDir: "desc",
      printIcon: false,
      randerCumponentSum: false,
      randerCumponentReport: false,
      componentIDTmp: [],
      formUserId: null,
      indexTabKey: null,
      dataFormInputAll: [],
      timeFormRenderCount: 0,
      timeFormRenderAll: 0,
      timeCheckStart: false,
      formDataListConst: [],
      ownedId: null,
      limitFormData: 10,
      dataFilter: {
        page: 1,
        limit: 20,
      },
      dataDistrict: [],
      dataSubDistrict: [],
      formDataList: [],
      dataLimit: [],
      handleScroll: 0,
      labelColumn: [],
      decode:null
    };
  },
  computed: {
    wordBack() {
      if (this.activeTab == 0 && this.tabPage == "detail") {
        return "รายการ";
      } else {
        return "Form list";
      }
    },
    user() {
      return this.$store.state.user;
    },
    tabPage() {
      return this.$store.state.tabPage;
    },
  },
  async mounted() {
     this.$store.commit("SET_TAB_PAGE", "list");
    if(typeof this.routerData.token != 'undefined' ){
     await this.decodeToken()
    }
    await this.getColumn();
    this.isLoadingPage = true;
    await this.fethForm();
   
    setTimeout(() => {
      this.startDataFilter();
    }, 500);
  },
  methods: {
    decodeToken(){
      const SECRET = "00f5vdd5r12fg1g[][dsdd122"; 
      const jwt = require('jsonwebtoken'); 
      let decoded = jwt.verify(this.routerData.token, SECRET);
      console.log('decoded',decoded);  
      this.decode = decoded
      this.$store.commit('SET_TAB_PAGE',decoded.tabPage)
      this.goToDetail()
    },
    changePage() {
      let dataConst = JSON.parse(JSON.stringify(this.formDataList));
      let start =
        this.dataFilter.page == 1
          ? Number(this.dataFilter.page) - 1
          : (Number(this.dataFilter.page) - 1) * Number(this.dataFilter.limit);
      let end = this.dataFilter.limit;

      this.dataLimit = dataConst.splice(start, end);
    },
    changePageView() {
      this.isViewComponent = this.isViewComponent ? false : true;
    },
    resetfilter() {
      this.labelColumn.map((data) => {
        this.dataFilter[data.column] = "";
      });
      this.dataFilter.page = 1;
      this.dataFilter.limit = 20;
      let href = `/form-data-list/${this.formId}`;
      if (this.user.userLevel == 50) {
        href += `/${this.$route.params.roleId}`;
      }
      typeof this.roleId != "undefined" ? (href += `/${this.roleId}`) : "";
      window.location = href;
      this.changePage();
    },
    fucFilter() {
      let filter = JSON.parse(JSON.stringify(this.formDataListConst));

      for (var i = 0; i < this.labelColumn.length; i++) {
        if (this.labelColumn[i].type == "select") {
          filter = filter.filter((search) => {
            if (
              typeof search.data[0].input[this.labelColumn[i].name] !=
                "undefined" &&
              search.data[0].input[this.labelColumn[i].name] !== null
            ) {
              return (
                search.data[0].input[this.labelColumn[i].name].label
                  .toLowerCase()
                  .indexOf(
                    this.dataFilter[this.labelColumn[i].name].toLowerCase()
                  ) > -1
              );
            } else {
              return search;
            }
          });
        } else if (this.labelColumn[i].type == "radio") {
          filter = filter.filter((search) => {
            if (
              typeof search.data[0].input[this.labelColumn[i].name] !=
                "undefined" &&
              search.data[0].input[this.labelColumn[i].name] !== null &&
              search.data[0].input[this.labelColumn[i].name].data != null
            ) {
              return (
                search.data[0].input[this.labelColumn[i].name].data.label
                  .toLowerCase()
                  .indexOf(
                    this.dataFilter[this.labelColumn[i].name].toLowerCase()
                  ) > -1
              );
            } else {
              return search;
            }
          });
        } else if (this.labelColumn[i].type == "checkbox") {
          filter = filter.filter((search) => {
            if (
              typeof search.data[0].input[this.labelColumn[i].name] !=
                "undefined" &&
              search.data[0].input[this.labelColumn[i].name] !== null &&
              search.data[0].input[this.labelColumn[i].name].length > 0
            ) {
              let label = search.data[0].input[this.labelColumn[i].name].filter(
                (a) => {
                  a.label
                    .toLowerCase()
                    .indexOf(
                      this.dataFilter[this.labelColumn[i].name].toLowerCase()
                    ) > -1;
                }
              );
              return label;
            } else {
              return search;
            }
          });
        } else {
          filter = filter.filter((search) => {
            if (
              typeof search.data[0].input[this.labelColumn[i].name] !=
                "undefined" &&
              search.data[0].input[this.labelColumn[i].name] !== null &&
              search.data[0].input[this.labelColumn[i].name] !== ""
            ) {
              return (
                search.data[0].input[this.labelColumn[i].name]
                  .toLowerCase()
                  .indexOf(
                    this.dataFilter[this.labelColumn[i].name].toLowerCase()
                  ) > -1
              );
            } else {
              return search;
            }
          });
        }
      }
      // this.labelColumn.map(obj=>{
      //     if(obj.type == 'select'){
      //         if(typeof filter[0].data[0].input[obj.name] != 'undefined' &&  filter[0].data[0].input[obj.name] !== null){
      //             filter = filter.filter(search => typeof search.data[0].input[obj.name] != 'undefined' &&  search.data[0].input[obj.name] !== null && search.data[0].input[obj.name].label.toLowerCase().indexOf(this.dataFilter[obj.name].toLowerCase()) >-1 )
      //         }
      //     }else if(obj.type == 'radio'){
      //         if(typeof filter[0].data[0].input[obj.name] != 'undefined' &&  filter[0].data[0].input[obj.name] !== null){
      //             filter = filter.filter(search => typeof search.data[0].input[obj.name] != 'undefined' &&  search.data[0].input[obj.name] !== null && search.data[0].input[obj.name].data.label.toLowerCase().indexOf(this.dataFilter[obj.name].toLowerCase()) >-1 )
      //         }
      //     }else if(obj.type == "checkbox"){
      //         if(typeof filter[0].data[0].input[obj.name] != 'undefined' &&  filter[0].data[0].input[obj.name] !== null &&  filter[0].data[0].input[obj.name].length > 0){
      //             console.log('1')
      //             filter = filter.filter(search => {
      //                 let label = search.data[0].input[obj.name].filter(a =>{
      //                     a.label.toLowerCase().indexOf(this.dataFilter[obj.name].toLowerCase()) >-1
      //                 })
      //                 return label
      //             })
      //         }
      //         console.log('2')
      //     }else{
      //          if(typeof filter[0].data[0].input[obj.name] != 'undefined' &&  filter[0].data[0].input[obj.name] !== null){
      //         filter = filter.filter(search => typeof search.data[0].input[obj.name] != 'undefined' &&  search.data[0].input[obj.name] !== null && search.data[0].input[obj.name].toLowerCase().indexOf(this.dataFilter[obj.name].toLowerCase()) >-1 )
      //         }
      //     }
      // })
      this.formDataList = filter;
      this.changePage();
    },
    getColumn() {
      this.labelColumn = [];
      let token = this.decode != null ? this.decode.token : this.user.token
      HTTP.defaults.headers.common.Authorization = `Bearer ${token}`;
      HTTP.get(`form/${this.formId}`).then((res) => {
        console.log(`form/${this.formId}`, res.data.obj.formName);
        if (res.data.success) {
          for (var i = 0; i < res.data.obj.formName.length; i++) {
            this.dataFilter[res.data.obj.formName[i].name] = "";
            this.labelColumn = res.data.obj.formName;
          }
        }
      });
      // if(typeof this.routerData != 'undefined' && this.routerData != ''){
      //     typeof this.routerData.limit != 'undefined' ? this.dataFilter.limit = this.routerData.limit : null
      //     typeof this.routerData.page != 'undefined' ? this.dataFilter.page = this.routerData.page : null
      //     typeof this.routerData.tab != 'undefined' ? this.activeTab = this.routerData.tab : this.activeTab = 0
      // }
    },
    startDataFilter() {
      Object.keys(this.routerData).map((data) => {
        this.dataFilter[data] = this.routerData[data];
        if (typeof this.$refs[data] != "undefined") {
          this.$refs[data][0].value = this.routerData[data];
        }
      });
      if (typeof this.routerData != "undefined" && this.routerData != "") {
        typeof this.routerData.limit != "undefined"
          ? (this.dataFilter.limit = this.routerData.limit)
          : null;
        typeof this.routerData.page != "undefined"
          ? (this.dataFilter.page = this.routerData.page)
          : null;
        typeof this.routerData.tab != "undefined"
          ? (this.activeTab = Number(this.routerData.tab))
          : (this.activeTab = 0);
      }
      if(typeof this.routerData.token != 'undefined' ){
        this.goToDetail()
      }
    },
    setDataFilter(tab) {
      let href = `/form-data-list/${this.formId}`;
      if (this.user.userLevel == 50) {
        href += `/${this.$route.params.roleId}`;
      }
      typeof this.roleId != "undefined" ? (href += `/${this.roleId}`) : "";
      href += "?";
      console.log(this.dataFilter);
      Object.keys(this.dataFilter).map((data) => {
        if (data == "page" || data == "tab" || data == "limit") {
          href += `${data}=${this.dataFilter[data]}&`;
        } else {
          console.log(data);
          if (
            typeof this.$refs[data] != "undefined" &&
            this.$refs[data][0].value != ""
          ) {
            href += `${data}=${this.$refs[data][0].value}&`;
          }
        }
      });
      window.location = href;
    },
    setUrl(page) {
      let href = `/form-data-list/${this.formId}`;
      if (this.user.userLevel == 50) {
        href += `/${this.$route.params.roleId}`;
      }
      typeof this.roleId != "undefined" ? (href += `/${this.roleId}`) : "";
      href += "?";

      Object.keys(this.dataFilter).map((data) => {
        if (data == "page" || data == "tab" || data == "limit") {
          href += `${data}=${this.dataFilter[data]}&`;
        } else {
          if (
            typeof this.$refs[data] != "undefined" &&
            this.$refs[data].length > 0 &&
            this.$refs[data][0].value != ""
          ) {
            href += `${data}=${this.$refs[data][0].value}&`;
          }
        }
      });
      href += `tab=${this.activeTab}`;
      return href;
    },
    backPage() {
      if (this.activeTab == 0 && this.tabPage == "detail") {
        this.printIcon = false;
        let href = `/form-data-list/${this.formId}`;
        if (this.user.userLevel == 50) {
          href += `/${this.$route.params.roleId}`;
        }
        this.$router.push(href).catch(() => {});
        this.$store.commit("SET_TAB_PAGE", "list");
      } else {
        this.$router.push("/form-list");
      }
    },
    changTap() {
      if (Object.values(this.forms).length > 0) {
        this.formsChildren = [];
        this.formsChildren.push(this.forms.components[0]);
        this.fetchLoading();
      }

      this.$store.commit("SET_TAB_PAGE", "list");
      if (Object.values(this.forms).length > 0) {
        if (this.activeTab === 1) {
          this.checkfetchFormname();
        }

        if (this.activeTab === 2) {
          this.setDataSummary();
        }
      } else {
        this.randerCumponentSum = true;
        this.randerCumponentReport = true;
      }

      if (this.tabPage === "detail") {
        this.printIcon = true;
      } else {
        this.printIcon = false;
      }
    },
    async checkfetchFormname() {
      this.tiltleTableFormReport = [];
      if (this.forms.type === "template") {
        this.randerCumponentReport = false;
        let data = {
          components: this.componentIDTmp,
        };

        let token = this.decode != null ? this.decode.token : this.user.token
        HTTP.defaults.headers.common.Authorization = `Bearer ${token}`;
        await HTTP.post(`form/name/template`, data)
          .then((res) => {
            if (res.data.success) {
              res.data.obj.obj.map((item) => {
                if (typeof item.title !== "undefined") {
                  let type =
                    typeof item.type !== "undefined" ? item.type : null;
                  this.tiltleTableFormReport.push({
                    title: item.title,
                    field: item.name,
                    type: type,
                    visible: true,
                  });
                }
              });
            } else {
              this.isLoadingPage = false;
              this.tiltleTableFormReport = [];
            }
            setTimeout(() => {
              this.randerCumponentReport = true;
            }, 1000);
          })
          .catch((e) => {
            setTimeout(() => {
              this.randerCumponentReport = true;
            }, 1000);
            console.log("api/get/form/name/on/template/error", e);
          });
      } else {
        this.fethFormName();
      }
    },
    async fethFormName() {
      this.randerCumponentReport = false;
      let data = {
        componentId: this.forms._id,
      };

      let token = this.decode != null ? this.decode.token : this.user.token
      HTTP.defaults.headers.common.Authorization = `Bearer ${token}`;
      await HTTP.post(`get/form/name`, data)
        .then((res) => {
          if (res.data.success) {
            res.data.obj.obj.map((item) => {
              if (typeof item.title !== "undefined") {
                let type = typeof item.type !== "undefined" ? item.type : null;
                this.tiltleTableFormReport.push({
                  title: item.title,
                  field: item.name,
                  type: type,
                  visible: true,
                });
              }
            });
          } else {
            this.isLoadingPage = false;
            this.tiltleTableFormReport = [];
          }
          setTimeout(() => {
            this.randerCumponentReport = true;
          }, 1000);
        })
        .catch((e) => {
          setTimeout(() => {
            this.randerCumponentReport = true;
          }, 1000);
          console.log("api/get/form/name/by/component/id/error", e);
        });
    },
    onPrint() {
      window.print();
    },
    sortBy(s) {
      if (s === this.currentSort) {
        this.currentSortDir = this.currentSortDir === "asc" ? "desc" : "asc";
      }
      this.currentSort = s;
    },

    async fethForm() {
      this.timeFormRenderCount = 0;
      this.timeFormRenderAll = 0;
      this.timeCheckStart = false;
      let token = this.decode != null ? this.decode.token : this.user.token
      HTTP.defaults.headers.common.Authorization = `Bearer ${token}`;
      await HTTP.get(`get/form/${this.formId}`)
        .then((res) => {
          console.log(`get/form/${this.formId}`, res);
          if (res.data.success) {
            let data = res.data.obj.obj.form;
            let type = res.data.obj.obj.type;
            if (type === "component") {
              this.forms = {
                _id: data._id,
                type: type,
                name: data.name,
                components: data.components,
              };

              if (Object.values(this.forms).length > 0) {
                this.asideMenu =
                  this.forms.components.length > 0
                    ? this.forms.components[0].key
                    : null;
                this.formsChildren.push(this.forms.components[0]);
              }

              this.fetchLoading();
              this.isLoadingPage = false;
            } else {
              if (Object.values(data).length > 0) {
                this.forms = {
                  _id: data._id,
                  type: type,
                  name: data.name,
                  components: [],
                };
                this.timeFormRenderAll =
                  this.timeFormRenderAll + data.components.length;

                for (let index = 0; index < data.components.length; index++) {
                  setTimeout(() => {
                    this.componentIDTmp.push(
                      data.components[index].componentId
                    );
                    this.getComponent(
                      data.components[index].componentId,
                      this.forms.components
                    ).then(() => {
                      this.fetchComponentChildren(
                        data.components[index].children,
                        this.forms.components[index]
                      );
                    });
                  }, 500 * index);
                }
              } else {
                this.fetchLoading();
                this.isLoadingPage = false;
              }
            }

            this.renderFormAside = true;
          } else {
            this.forms = {};
          }
        })
        .catch((e) => {
          console.log("fethForm error", e);
        })
        .finally(() => {
          if (Object.values(this.forms).length > 0) {
            this.checkfetchFormname();
            this.randerCumponentReport = true;
          }
        });
    },
    async fetchLoading() {
      this.isLoadingPage = true;
      this.compeleteKey = [];
      await this.fetchDataForm();

      setTimeout(() => {
        this.isLoadingPage = false;
      }, 1000);
    },
    setCompleteMenuMain(index) {
      if (
        Object.values(this.forms).length > 0 &&
        this.forms.components[index].componentData.length === 0
      ) {
        this.compeleteKey.push(this.forms.components[index].key);
      }

      return true;
    },
    async getComponent(id, form) {
      let token = this.decode != null ? this.decode.token : this.user.token
      HTTP.defaults.headers.common.Authorization = `Bearer ${token}`;
      await HTTP.get(`get/form/${id}`)
        .then((res) => {
          if (res.data.success) {
            let data = res.data.obj.obj.form;
            if (typeof data.components !== "undefined") {
              for (let index = 0; index < data.components.length; index++) {
                form.push(data.components[index]);
              }
            }
            this.timeFormRenderCount = this.timeFormRenderCount + 1;

            if (
              this.timeFormRenderCount === this.timeFormRenderAll &&
              this.timeCheckStart
            ) {
              if (Object.values(this.forms).length > 0) {
                this.asideMenu =
                  this.forms.components.length > 0
                    ? this.forms.components[0].key
                    : null;
                this.formsChildren.push(this.forms.components[0]);
              }

              this.fetchLoading();
              this.isLoadingPage = false;
            }
          } else {
            this.form = [];
          }

          return true;
        })
        .catch((e) => {
          console.log("get/component/by/id/prod/error", e);
        });
    },
    async fetchComponentChildren(component, form) {
      let res = null;
      this.timeCheckStart = true;
      if (component.length > 0) {
        this.timeFormRenderAll = this.timeFormRenderAll + component.length;

        for (let index = 0; index < component.length; index++) {
          setTimeout(() => {
            if (typeof form !== "undefined") {
              this.componentIDTmp.push(component[index].componentId);
              this.getComponent(component[index].componentId, form.children);
            }

            res = form;
            if (component[index].length > 0) {
              this.fetchComponentChildren(component[index].children, res);
            }
          }, 500 * index);
        }
      }
      return true;
    },
    setDataSummary() {
      this.randerCumponentSum = false;
      this.dataFormInputAll = [];
      this.formDataListConst.map((data) => {
        let summary = {
          input: data.data[0].input,
        };

        this.dataFormInputAll.push(summary);
      });
      this.randerCumponentSum = true;
    },
    async fetchDataForm() {
      let obj = {
        data: [{ componentId: this.forms._id }],
      };

      if (this.decode != null){
        obj.data.push({ userId: this.decode.roleId });
      }else if(this.user.userLevel == 60) {
        obj.data.push({ roleId: this.user._id });
      } else{
        obj.data.push({ userId: this.user._id });
      }

      await HTTP.post(`get/data`, obj)
        .then(async (res) => {
          if (res.data.success) {
            this.formDataListConst = res.data.obj.obj;
            res.data.obj.obj.map(async (data) => {
              if (this.dataDistrict.length > 0) {
                let filterDistrict = this.dataDistrict.filter(
                  (search) => search.value == data.data[0].input.DistrictEcn
                );
                if (filterDistrict.length == 0) {
                  this.dataDistrict.push({
                    label: data.data[0].input.DistrictEcn,
                    value: data.data[0].input.DistrictEcn,
                  });
                }
              } else {
                this.dataDistrict.push({
                  label: data.data[0].input.DistrictEcn,
                  value: data.data[0].input.DistrictEcn,
                });
              }

              if (this.dataSubDistrict.length > 0) {
                let filterSubDistrict = this.dataSubDistrict.filter(
                  (search) => search.value == data.data[0].input.subDistrictEcn
                );
                if (filterSubDistrict.length == 0) {
                  this.dataSubDistrict.push({
                    label: data.data[0].input.subDistrictEcn,
                    value: data.data[0].input.subDistrictEcn,
                  });
                }
              } else {
                this.dataSubDistrict.push({
                  label: data.data[0].input.subDistrictEcn,
                  value: data.data[0].input.subDistrictEcn,
                });
              }
            });
          } else {
            this.formDataListConst = [];
          }
        })
        .catch((e) => {
          console.log("get/data/form/prod/error", e);
        })
        .finally(() => {
          setTimeout(() => {
            this.fucFilter();
          }, 1000);
          this.randerCumponentSum = true;
        });
    },
    async setValueForm(components) {
      let value = [];

      await components.map(async (component) => {
        if (typeof this.dataFormComponent[component.key] !== "undefined") {
          this.inputFormComponent[component.key] = [];

          for (let index in this.dataFormComponent[component.key]) {
            this.inputFormComponent[component.key].push(
              this.dataFormComponent[component.key][index]
            );
            for (let indexData in this.dataFormComponent[component.key][index]
              .componentData) {
              let display = component.componentData[indexData].display;
              let options = component.componentData[indexData].options;
              let data = this.dataFormComponent[component.key][index]
                .componentData[indexData];
              data.display = display;
              data.options = options;
              this.setDataInput(this.dataFormInput[data.name], data, component);
              if (
                typeof this.dataFormInputAdd[data.name] !== "undefined" &&
                this.dataFormInputAdd[data.name].length > 0
              ) {
                this.inputFormData[data.name] = [];
                for (let indexAdd in this.dataFormInputAdd[data.name]) {
                  this.dataFormInputAdd[data.name][indexAdd].display = display;
                  this.dataFormInputAdd[data.name][indexAdd].options = options;
                  let name = this.dataFormInputAdd[data.name][indexAdd].name;
                  this.inputFormData[data.name].push(
                    this.dataFormInputAdd[data.name][indexAdd]
                  );
                  this.setDataInput(
                    this.dataFormInput[name],
                    this.dataFormInputAdd[data.name][indexAdd],
                    component
                  );
                }
              }
            }
          }
        }

        await component.componentData.map((item) => {
          this.setDataInput(this.dataFormInput[item.name], item, component);
          if (
            typeof this.dataFormInputAdd[item.name] !== "undefined" &&
            this.dataFormInputAdd[item.name].length > 0
          ) {
            this.inputFormData[item.name] = [];
            for (
              let index = 0;
              index < this.dataFormInputAdd[item.name].length;
              index++
            ) {
              this.dataFormInputAdd[item.name][index].display = item.display;
              this.dataFormInputAdd[item.name][index].options = item.options;
              let name = this.dataFormInputAdd[item.name][index].name;
              this.inputFormData[item.name].push(
                this.dataFormInputAdd[item.name][index]
              );
              this.setDataInput(
                this.dataFormInput[name],
                this.dataFormInputAdd[item.name][index],
                component
              );
            }
          }
        });

        if (component.children.length > 0) {
          await this.setValueForm(component.children);
        }
        return true;
      });
    },
    setDataInput(input, item, component) {
      let inputData = input;

      if (item.type === "checkbox") {
        this.inputValue[item.name] =
          typeof inputData !== "undefined" ? inputData : [];
        if (typeof inputData !== "undefined") {
          this.checkModelValue[item.name] = [];

          for (let index = 0; index < inputData.length; index++) {
            if (inputData[index] != null) {
              this.checkModelValue[item.name].push({
                label: inputData[index].label,
                value: inputData[index].value,
                userValue: inputData[index].userValue,
                index: inputData[index].index,
              });
            }
          }

          for (let index = 0; index < item.display.value.length; index++) {
            let data = [];

            if (typeof inputData[0] != "undefined") {
              data = inputData.filter(
                (itemInput) =>
                  itemInput.label === item.display.value[index].label
              );
            }
            if (
              typeof item.display.value[index] !== "undefined" &&
              item.display.value[index] != null &&
              item.display.value[index].userValue === true
            ) {
              if (data.length > 0) {
                this.checkVarDes[item.name + data[0].index] = {
                  index: index,
                  des: data[0].des,
                };
              } else {
                this.checkVarDes[item.name + index] = {
                  index: index,
                  des: null,
                };
              }
            }
            if (
              item.display.value[index].Keyid !== "" &&
              typeof inputData !== "undefined"
            ) {
              if (data.length > 0) {
                this.matchId[item.display.value[index].Keyid] =
                  item.display.value[index].Keyid;
                this.setMatchId(
                  this.checkModelValue[item.name],
                  item.display.value[index],
                  component,
                  "checkbox"
                );
              }
            }
          }
        } else {
          this.checkModelValue[item.name] = [];
          for (let index = 0; index < item.display.value.length; index++) {
            if (
              typeof item.display.value[index].userValue !== "undefined" &&
              item.display.value[index].userValue !== null &&
              item.display.value[index].userValue === true
            ) {
              this.checkVarDes[item.name + index] = { index: index, des: null };
            }

            if (item.display.value[index].Keyid !== "") {
              this.matchId[item.display.value[index].Keyid] = "";
            }
          }
        }
      } else if (item.type === "date") {
        this.inputValue[item.name] =
          typeof inputData !== "undefined" ? new Date(inputData) : null;
      } else if (item.type === "file") {
        let defaultInput = item.options.multiple === true ? [] : null;
        this.inputValue[item.name] =
          typeof inputData !== "undefined" &&
          inputData !== null &&
          typeof inputData.length !== 0
            ? inputData
            : defaultInput;
      } else if (item.type === "radio") {
        this.inputValue[item.name] =
          typeof inputData !== "undefined"
            ? { data: inputData.data, des: null }
            : { data: null, des: null };
        for (let index = 0; index < item.display.value.length; index++) {
          if (
            typeof inputData !== "undefined" &&
            item.display.value[index].userValue != null &&
            item.display.value[index].userValue === true
          ) {
            this.inputValue[item.name]["des"] =
              typeof inputData !== "undefined" ? inputData.des : null;
          }

          if (item.display.value[index].Keyid !== "") {
            if (
              typeof inputData !== "undefined" &&
              inputData.data !== null &&
              inputData.data.label === item.display.value[index].label
            ) {
              this.matchId[item.display.value[index].Keyid] =
                item.display.value[index].Keyid;
              this.setMatchId(
                item.display.value,
                item.display.value[index],
                component,
                "checkbox"
              );
            } else {
              this.matchId[item.display.value[index].Keyid] = "";
            }
          }
        }
      } else {
        this.inputValue[item.name] =
          typeof inputData !== "undefined" ? inputData : null;
        if (
          typeof item.options !== "undefined" &&
          typeof item.options.repeat !== "undefined" &&
          item.options.repeat === true
        ) {
          if (typeof this.dataKpi[item.name] !== "undefined") {
            let obj = {
              repeatStart: item.options.repeatStart,
              everyRepeat: item.options.everyRepeat,
              repeatStop: item.options.repeatStop,
            };
            this.dataInputKpi[item.name] = {
              type: item.type,
              input: this.dataKpi[item.name].input,
              lastUpdate: new Date(this.dataKpi[item.name].lastUpdate),
              repeatStop: false,
              repeat: obj,
              nameLabel: item.display.label,
            };

            let count = 1;
            let repeatDate = new Date(item.options.repeatStart);
            let repeatStartNum = repeatDate.getMonth();
            let updateDateForm =
              new Date(this.dataKpi[item.name].lastUpdate).getFullYear() +
              "-" +
              (new Date(this.dataKpi[item.name].lastUpdate).getMonth() + 1) +
              "-" +
              new Date(this.dataKpi[item.name].lastUpdate).getDate();

            while (repeatDate.getTime() <= new Date().getTime()) {
              if (
                typeof this.dataKpi[item.name].lastUpdate !== "undefined" &&
                new Date().getTime() >= repeatDate.getTime()
              ) {
                if (new Date(updateDateForm).getTime() < repeatDate.getTime()) {
                  this.inputValue[item.name] = null;
                } else {
                  this.inputValue[item.name] =
                    typeof inputData !== "undefined" ? inputData : null;
                }
              }

              repeatDate = new Date(item.options.repeatStart);
              repeatDate.setMonth(
                repeatStartNum + item.options.everyRepeat * count,
                1
              );
              count++;
            }
          } else {
            let obj = {
              repeatStart: item.options.repeatStart,
              everyRepeat: item.options.everyRepeat,
              repeatStop: item.options.repeatStop,
            };
            this.dataInputKpi[item.name] = {
              type: item.type,
              input: "",
              lastUpdate: null,
              repeatStop: true,
              repeat: obj,
              nameLabel: item.display.label,
            };
          }
        }
      }

      return true;
    },
    async setValidForm(components) {
      await components.map(async (component) => {
        let filter = this.compeleteKey.filter(
          (filter) => filter === component.key
        );
        if (filter.length === 0) {
          this.compeleteKey.push(component.key);
        }

        if (typeof this.dataFormComponent[component.key] !== "undefined") {
          for (let index in this.dataFormComponent[component.key]) {
            for (let indexData in this.dataFormComponent[component.key][index]
              .componentData) {
              let validation = component.componentData[indexData].validation;
              let data = this.dataFormComponent[component.key][index]
                .componentData[indexData];
              data.validation = validation;
              await this.setValidInput(data);
              if (
                typeof this.dataFormInputAdd[data.name] !== "undefined" &&
                this.dataFormInputAdd[data.name].length > 0
              ) {
                for (let indexAdd in this.dataFormInputAdd[data.name]) {
                  this.dataFormInputAdd[data.name][
                    indexAdd
                  ].validation = validation;
                  await this.setValidInput(
                    this.dataFormInputAdd[data.name][indexAdd]
                  );
                }
              }
            }
          }
        }

        await component.componentData.map(async (item) => {
          await this.setValidInput(item);
          if (
            typeof this.dataFormInputAdd[item.name] !== "undefined" &&
            this.dataFormInputAdd[item.name].length > 0
          ) {
            for (
              let index = 0;
              index < this.dataFormInputAdd[item.name].length;
              index++
            ) {
              this.dataFormInputAdd[item.name][index].validation =
                item.validation;
              await this.setValidInput(this.dataFormInputAdd[item.name][index]);
            }
          }
        });

        if (component.children.length > 0) {
          await this.setValidForm(component.children);
        }
      });
      return true;
    },
    setValidInput(item) {
      if (
        typeof item.display.matchid !== "undefined" &&
        item.display.matchid !== ""
      ) {
        this.inputValidate[item.name] = {
          name: item.name,
          validation: item.validation,
          type: item.type,
          valid: false,
          hidden: true,
        };
        if (item.type === "radio") {
          for (let index = 0; index < item.display.value.length; index++) {
            if (
              typeof item.display.value[index].userValue !== "undefined" &&
              item.display.value[index].userValue !== null &&
              item.display.value[index].userValue === true
            ) {
              this.inputValidate[item.name + "UserValue" + index] = {
                name: item.name,
                validation: { errorMsg: "กรุณากรอกข้อความ", required: true },
                type: "radioDes",
                valid: false,
                hidden: true,
              };
            }
          }
        }

        if (item.type === "checkbox") {
          for (let index = 0; index < item.display.value.length; index++) {
            if (
              typeof item.display.value[index].userValue !== "undefined" &&
              item.display.value[index].userValue !== null &&
              item.display.value[index].userValue === true
            ) {
              this.inputValidate[item.name + "UserValue" + index] = {
                name: item.name,
                validation: { errorMsg: "กรุณากรอกข้อความ", required: true },
                type: "checkBoxDes",
                valid: false,
                hidden: true,
              };
            }
          }
        }
      } else {
        this.inputValidate[item.name] = {
          name: item.name,
          validation: item.validation,
          type: item.type,
          valid: false,
          hidden: false,
        };
        if (item.type === "radio") {
          for (let index = 0; index < item.display.value.length; index++) {
            if (
              typeof item.display.value[index].userValue !== "undefined" &&
              item.display.value[index].userValue !== null &&
              item.display.value[index].userValue === true
            ) {
              this.inputValidate[item.name + "UserValue" + index] = {
                name: item.name,
                validation: { errorMsg: "กรุณากรอกข้อความ", required: true },
                type: "radioDes",
                valid: false,
                hidden: false,
              };
            }
          }
        }

        if (item.type === "checkbox") {
          for (let index = 0; index < item.display.value.length; index++) {
            if (
              typeof item.display.value[index].userValue !== "undefined" &&
              item.display.value[index].userValue !== null &&
              item.display.value[index].userValue === true
            ) {
              this.inputValidate[item.name + "UserValue" + index] = {
                name: item.name,
                validation: { errorMsg: "กรุณากรอกข้อความ", required: true },
                type: "checkBoxDes",
                valid: false,
                hidden: false,
              };
            }
          }
        }
      }

      return true;
    },
    async setValueMatch(components, keyId, status) {
      await components.map(async (component) => {
        await component.componentData.map((item) => {
          if (
            typeof item.display.matchid !== "undefined" &&
            typeof item.display.matchid !== ""
          ) {
            if (keyId === item.display.matchid) {
              if (status === true) {
                this.inputValidate[item.name] = {
                  name: item.name,
                  validation: item.validation,
                  type: item.type,
                  valid: false,
                  hidden: false,
                };
              } else {
                this.inputValidate[item.name] = {
                  name: item.name,
                  validation: item.validation,
                  type: item.type,
                  valid: false,
                  hidden: true,
                };
              }

              if (item.type === "radio") {
                for (
                  let index = 0;
                  index < item.display.value.length;
                  index++
                ) {
                  if (
                    typeof item.display.value[index].userValue !==
                      "undefined" &&
                    item.display.value[index].userValue !== null &&
                    item.display.value[index].userValue === true
                  ) {
                    if (status === true) {
                      this.inputValidate[item.name + "UserValue" + index] = {
                        name: item.name,
                        validation: {
                          errorMsg: "กรุณากรอกข้อความ",
                          required: true,
                        },
                        type: "radioDes",
                        valid: false,
                        hidden: false,
                      };
                    } else {
                      this.inputValidate[item.name + "UserValue" + index] = {
                        name: item.name,
                        validation: {
                          errorMsg: "กรุณากรอกข้อความ",
                          required: true,
                        },
                        type: "radioDes",
                        valid: false,
                        hidden: true,
                      };
                    }
                  }
                }
              }

              if (item.type === "checkbox") {
                for (
                  let index = 0;
                  index < item.display.value.length;
                  index++
                ) {
                  if (
                    typeof item.display.value[index].userValue !==
                      "undefined" &&
                    item.display.value[index].userValue !== null &&
                    item.display.value[index].userValue === true
                  ) {
                    if (status === true) {
                      this.inputValidate[item.name + "UserValue" + index] = {
                        name: item.name,
                        validation: {
                          errorMsg: "กรุณากรอกข้อความ",
                          required: true,
                        },
                        type: "checkBoxDes",
                        valid: false,
                        hidden: false,
                      };
                    } else {
                      this.inputValidate[item.name + "UserValue" + index] = {
                        name: item.name,
                        validation: {
                          errorMsg: "กรุณากรอกข้อความ",
                          required: true,
                        },
                        type: "checkBoxDes",
                        valid: false,
                        hidden: true,
                      };
                    }
                  }
                }
              }

              if (item.type === "checkbox") {
                this.inputValue[item.name] = [];
                this.checkModelValue[item.name] = [];
                for (
                  let index = 0;
                  index < item.display.value.length;
                  index++
                ) {
                  if (item.display.value[index].Keyid !== "") {
                    this.matchId[item.display.value[index].Keyid] = "";
                  }
                  if (
                    typeof item.display.value[index].userValue !==
                      "undefined" &&
                    item.display.value[index].userValue !== null &&
                    item.display.value[index].userValue === true
                  ) {
                    this.checkVarDes[item.name + index] = {
                      index: index,
                      des: null,
                    };
                  }
                }
              } else if (item.type === "date") {
                this.inputValue[item.name] = null;
              } else if (item.type === "file") {
                this.inputValue[item.name] = [];
              } else if (item.type === "radio") {
                this.inputValue[item.name] = { data: null, des: null };
                for (
                  let index = 0;
                  index < item.display.value.length;
                  index++
                ) {
                  if (item.display.value[index].Keyid !== "") {
                    this.matchId[item.display.value[index].Keyid] = "";
                  }
                }
              } else {
                this.inputValue[item.name] = null;
              }
            }
          }
        });

        if (component.children.length > 0) {
          await this.setValueMatch(component.children, keyId);
        } else {
          //console.log("this.matchId",this.matchId)
          setTimeout(() => {
            this.renderForm = true;
            window.scrollTo(0, this.handleScroll);
          }, 1);
        }
      });
    },
    getCompelete(key) {
      let data = this.compeleteFormData.filter((item) => item === key);
      if (data.length > 0) {
        return true;
      } else {
        return false;
      }
    },
    setRenderComponent(status, scroll) {
      console.log("sdafgh", scroll);
      this.renderForm = status;
      setTimeout(() => {
        if (status === true) {
          this.renderForm = false;
        } else {
          this.renderForm = true;
        }
      }, 1);
    },
    setMatchId(data, value, component, type) {
      this.handleScroll = window.scrollY;
      if (type === "radio") {
        if (value.Keyid !== "") {
          for (let index in data) {
            if (data[index].Keyid === value.Keyid) {
              this.matchId[data[index].Keyid] = value.Keyid;
              this.renderForm = false;
              this.setValueMatch([component], data[index].Keyid, true);
            } else {
              this.matchId[data[index].Keyid] = "";
              this.renderForm = false;
              this.setValueMatch([component], data[index].Keyid, false);
            }
          }
        }
      } else {
        let res = data.filter((item) => item.label === value.label);
        if (value.Keyid !== "") {
          if (res.length > 0) {
            this.matchId[value.Keyid] = value.Keyid;
            this.renderForm = false;
            this.setValueMatch([component], value.Keyid, true);
          } else {
            this.matchId[value.Keyid] = "";
            this.renderForm = false;
            this.setValueMatch([component], value.Keyid, false);
          }
        }
      }
    },
    getCompeleteStep(component) {
      let data = component.filter(
        (item) => this.getCompelete(item.key) === true
      );
      return data.length;
    },
    addInput(input, component) {
      this.renderForm = false;
      let obj = JSON.parse(JSON.stringify(input));

      if (typeof this.inputFormData[input.name] === "undefined") {
        this.inputFormData[input.name] = [];
      }

      let newName = input.name + "" + this.inputFormData[input.name].length;
      obj["name"] = newName;

      this.setDataInput(this.inputValue[newName], obj, component);

      this.setValidInput(obj);
      this.inputFormData[input.name].push(obj);
      setTimeout(() => {
        this.renderForm = true;
      }, 1);
    },
    delInput(name, index) {
      this.renderForm = false;

      let formData = JSON.parse(JSON.stringify(this.inputFormData[name]));
      let arr = [];
      let component = [];

      for (let indexData in formData) {
        if (Number(indexData) !== index) {
          arr.push({
            value: this.inputValue[name + "" + indexData],
            validate: this.inputValidate[name + "" + indexData],
          });
          component.push(this.inputFormData[name][indexData]);
        }
        let item = formData[indexData];
        if (item.type === "radio") {
          for (let index = 0; index < item.display.value.length; index++) {
            if (
              typeof item.display.value[index].userValue !== "undefined" &&
              item.display.value[index].userValue !== null &&
              item.display.value[index].userValue === true
            ) {
              delete this.inputValidate[item.name + "UserValue" + index];
            }
          }
        } else if (item.type === "checkbox") {
          for (let index = 0; index < item.display.value.length; index++) {
            if (
              typeof item.display.value[index].userValue !== "undefined" &&
              item.display.value[index].userValue !== null &&
              item.display.value[index].userValue === true
            ) {
              delete this.inputValidate[item.name + "UserValue" + index];
            }
          }
        }

        delete this.inputValidate[name + "" + indexData];
        delete this.inputValue[name + "" + indexData];
      }
      this.inputFormData[name] = [];
      for (let newIndex in arr) {
        let newName = name + "" + newIndex;
        component[newIndex].name = newName;
        this.setDataInput(arr[newIndex].value, component[newIndex], formData);
        this.setValidInput(component[newIndex]);
        this.inputFormData[name].push(component[newIndex]);
      }

      setTimeout(() => {
        this.renderForm = true;
      }, 1);
    },
    addForm(input) {
      this.renderForm = false;
      let obj = JSON.parse(JSON.stringify(input));
      if (typeof this.inputFormComponent[input.key] === "undefined") {
        this.inputFormComponent[input.key] = [];
      }
      for (var i in input.componentData) {
        let newName =
          input.key +
          "" +
          obj.componentData[i].name +
          "" +
          this.inputFormComponent[input.key].length;
        obj.componentData[i].fristName = obj.componentData[i].name;
        obj.componentData[i].name = newName;
        let component = JSON.parse(JSON.stringify(input.componentData[i]));

        component.name = newName;
        this.setDataInput(this.inputValue[newName], component, input);
        this.setValidInput(component);
      }

      this.inputFormComponent[input.key].push(obj);
      setTimeout(() => {
        this.renderForm = true;
      }, 1);
    },
    delForm(name, index) {
      this.renderForm = false;
      let obj = JSON.parse(JSON.stringify(this.inputFormComponent[name]));

      let arr = [];
      let form = [];
      let component = [];

      for (let indexForm in obj) {
        if (Number(indexForm) !== index) {
          let value = [];
          let valid = [];
          for (let indexData in obj[indexForm].componentData) {
            let nameData = obj[indexForm].componentData[indexData].name;
            value.push(this.inputValue[nameData]);
            valid.push(this.inputValidate[nameData]);
            if (typeof this.inputFormData[nameData] !== "undefined") {
              let formData = JSON.parse(
                JSON.stringify(this.inputFormData[nameData])
              );
              let inputData = [];
              let valueArr = [];
              let validArr = [];
              for (let indexDataAdd in formData) {
                inputData.push(formData[indexDataAdd]);
                valueArr.push(this.inputValue[nameData + "" + indexDataAdd]);
                validArr.push(this.inputValidate[nameData + "" + indexDataAdd]);
                arr.push({
                  value: this.inputValue[nameData + "" + indexDataAdd],
                  validate: this.inputValidate[nameData + "" + indexDataAdd],
                });
              }
              component.push({
                name: nameData,
                data: inputData,
                value: valueArr,
                valid: validArr,
              });
            }
          }
          form.push({ obj: obj[indexForm], value: value, valid: valid });
        }

        for (let indexData in obj[indexForm].componentData) {
          let nameData = obj[indexForm].componentData[indexData].name;
          let item = obj[indexForm].componentData[indexData];
          delete this.inputValue[nameData];
          delete this.inputValidate[nameData];
          if (item.type === "radio") {
            for (let index = 0; index < item.display.value.length; index++) {
              if (
                typeof item.display.value[index].userValue !== "undefined" &&
                item.display.value[index].userValue !== null &&
                item.display.value[index].userValue === true
              ) {
                delete this.inputValidate[item.name + "UserValue" + index];
              }
            }
          } else if (item.type === "checkbox") {
            for (let index = 0; index < item.display.value.length; index++) {
              if (
                typeof item.display.value[index].userValue !== "undefined" &&
                item.display.value[index].userValue !== null &&
                item.display.value[index].userValue === true
              ) {
                delete this.inputValidate[item.name + "UserValue" + index];
              }
            }
          }

          if (typeof this.inputFormData[nameData] !== "undefined") {
            let formData = JSON.parse(
              JSON.stringify(this.inputFormData[nameData])
            );
            for (let indexDataAdd in formData) {
              let itemAdd = formData[indexDataAdd];
              delete this.inputValidate[nameData + "" + indexDataAdd];
              delete this.inputValue[nameData + "" + indexDataAdd];
              if (itemAdd.type === "radio") {
                for (
                  let index = 0;
                  index < itemAdd.display.value.length;
                  index++
                ) {
                  if (
                    typeof itemAdd.display.value[index].userValue !==
                      "undefined" &&
                    itemAdd.display.value[index].userValue !== null &&
                    itemAdd.display.value[index].userValue === true
                  ) {
                    delete this.inputValidate[
                      itemAdd.name + "UserValue" + index
                    ];
                  }
                }
              } else if (itemAdd.type === "checkbox") {
                for (
                  let index = 0;
                  index < itemAdd.display.value.length;
                  index++
                ) {
                  if (
                    typeof itemAdd.display.value[index].userValue !==
                      "undefined" &&
                    itemAdd.display.value[index].userValue !== null &&
                    itemAdd.display.value[index].userValue === true
                  ) {
                    delete this.inputValidate[
                      itemAdd.name + "UserValue" + index
                    ];
                  }
                }
              }
            }
            delete this.inputFormData[nameData];
          }
        }
      }

      for (let newIndexComponent in component) {
        let componentData = component[newIndexComponent].data;
        let value = component[newIndexComponent].value;
        let valid = component[newIndexComponent].valid;
        let nameFormData =
          componentData.length > 0
            ? name + "" + componentData[0].fristName + "" + newIndexComponent
            : "";
        let data = {};
        this.inputFormData[nameFormData] = [];
        for (let newIndexData in componentData) {
          let nameInput =
            name +
            "" +
            componentData[newIndexData].fristName +
            "" +
            newIndexComponent +
            "" +
            newIndexData;
          componentData[newIndexData].name = nameInput;
          this.inputFormData[nameFormData].push(componentData[newIndexData]);
          this.setDataInput(
            value[newIndexData],
            componentData[newIndexData],
            componentData
          );
          this.setValidInput(componentData[newIndexData]);
        }
      }

      this.inputFormComponent[name] = [];
      for (let newIndexForm in form) {
        let componentData = form[newIndexForm].obj.componentData;
        let value = form[newIndexForm].value;
        let valid = form[newIndexForm].valid;
        for (let newIndexData in componentData) {
          let nameInput =
            name +
            "" +
            componentData[newIndexData].fristName +
            "" +
            newIndexForm;
          componentData[newIndexData].name = nameInput;
          this.setDataInput(
            value[newIndexData],
            componentData[newIndexData],
            componentData
          );
          this.setValidInput(componentData[newIndexData]);
        }
        this.inputFormComponent[name].push(form[newIndexForm].obj);
      }

      setTimeout(() => {
        this.renderForm = true;
      }, 1);
    },
    async goToDetail(input) {
      this.formsChildren = [];
      this.formsChildren.push(this.forms.components[0]);
      this.printIcon = true;
      this.asideMenu =
        this.forms.components.length > 0 ? this.forms.components[0].key : null;

      this.setDataFormUser(input);
      this.activeTab = 0;
      setTimeout(() => {
        this.$store.commit("SET_TAB_PAGE", "detail");
      }, 500);
    },
    setViewComponent(status) {
      this.isViewComponent = status;
    },
    async setFormComponent(data, index) {
      this.asideMenu = data.key;
      this.formsChildren = [];
      this.formsChildren.push(data);

      this.indexTabKey = index;

      let filter = this.formDataListConst.filter(
        (filter) => filter._id == this.formUserId
      );
      await this.setDataFormUser(filter[0]);
      this.menuActive = false;
    },
    setFormUserId(id) {
      let filter = this.formDataListConst.filter((filter) => filter._id == id);
      if (filter.length > 0) {
        this.updateDateForm = filter[0].updatedAt;
      }

      this.formUserId = id;
    },
    viewMoreform(number) {
      this.limitFormData = this.limitFormData + number;
    },
    async setDataFormUser(obj) {
      this.renderForm = false;
      this.isLoadingPage = true;
      this.inputValue = {};
      this.inputValidate = {};
      this.compeleteKey = [];
      this.compeleteFormDataAll = [];

      if (typeof obj !== "undefined") {
        if (
          typeof this.indexTabKey !== "undefined" &&
          this.indexTabKey !== null
        ) {
          await this.setCompleteMenuMain(this.indexTabKey);
        } else {
          this.compeleteFormData = obj.data[0].complete;
        }

        this.dataFormInput = obj.data[0].input;

        this.updateDateForm = obj.updatedAt;
        this.dataFormInputAdd =
          typeof obj.data[0].inputAdd !== "undefined"
            ? obj.data[0].inputAdd
            : {};
        this.dataFormComponent =
          typeof obj.data[0].inputForm !== "undefined"
            ? obj.data[0].inputForm
            : {};
        this.formUserId = obj._id;
        this.ownedId = obj.userId;
      } else {
        this.dataFormInput = {};
        this.dataFormInputAdd = {};
        this.dataFormComponent = {};
        this.compeleteFormData = [];
        this.updateDateForm = null;
        this.formUserId = "";
        this.ownedId = "";
      }

      if (Object.values(this.forms).length > 0) {
        await this.setValidForm(this.formsChildren);
        await this.setValueForm(this.forms.components);
      }

      setTimeout(() => {
        console.log("input", this.dataFormInput);
        this.renderForm = true;
        this.isLoadingPage = false;
        this.indexTabKey = null;
      }, 2000);
    },
  },
};
</script>
<style scoped>
.menuMobile {
  z-index: 1001;
  top: 2%;
  width: 32px;
  height: 32px;
  position: fixed;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  left: 1%;
  background: #fff;
  border-radius: 100%;
  -webkit-box-shadow: 1px 1px 10px 1px #636363;
  box-shadow: 1px 1px 10px 1px #636363;
}
.mobileSide.active {
  right: -200%;
}
.mobileSide {
  overflow: auto;
  padding: 25px;
  transition: all 0.3s;
  --webkit-transition: all 0.3s;
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  z-index: 1000;
  background: #fff;
  -webkit-box-shadow: 1px 1px 10px 1px #636363;
  box-shadow: 1px 1px 10px 1px #636363;
}
.iconPage.print {
  bottom: 110px;
  right: 30px;
}
.iconPage.viewEdit {
  bottom: 190px;
  right: 30px;
}
.iconPage {
  opacity: 0.6;
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  border-radius: 100%;
  font-size: 25px;
  width: 70px;
  height: 70px;
  color: #fff;
  z-index: 10000;
  background: rgba(109, 141, 243, 0.9);
}
.iconPage:hover {
  opacity: 1;
  background: #6d8df3;
  color: white;
}
.box-t-relative {
  position: relative;
  top: 65px;
  margin-left: 650px;
}
.box-t-relative-mobile {
  position: relative;
  top: 135px;
}
.text-green {
  color: #00a79d;
  margin: 0px 60px;
}
.is-radius {
  border-radius: 7.5px;
}
.tb-report section {
  background-color: #fff;
  margin: 15px;
  border-radius: 5px;
}
.icon-unflex .icon {
  display: unset !important;
}
.min-w-152 {
  min-width: 125px;
}
.m-h-35 {
  min-height: 35px;
}
.borderPhoto {
  max-width: 150px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.borderPhoto1 {
  border: 1px solid black;
  display: flex;
  justify-content: center;
  align-items: center;
}
.borderLogo {
  padding-left: 5px;
  max-width: 150px;
}
.flexend {
  display: flex;
  justify-content: flex-end;
  padding-right: 35px;
}
.pd-r-40 {
  padding-right: 80px;
  padding-top: 15px;
}
.marginLogo {
  margin: 25px 5px;
}
.border-bt {
  border-bottom: 1px solid black;
  margin: 10px;
}
.detailsHeader {
  display: flex;
  justify-content: center;
  flex-direction: column;
  margin: 0 25px;
}
.centeralignment {
  display: flex;
  justify-content: center;
  text-align: center;
}
.flexDate {
  display: flex;
  flex-direction: column;
  text-align: left;
  justify-content: flex-end;
  width: 100%;
  margin-left: 5px;
}
.flexMg {
  display: flex;
  margin: 0 15px;
}
.back-filter {
  position: relative;
  top: 80px;
  right: 260px;
  z-index: 10;
}
.notForm {
  color: #ccc;
}
.box-percent {
  border: solid;
  border-radius: 7.5px;
  border-color: #00a79d;
  color: #00a79d;
  height: 70px;
  margin: 20px;
}
.box-percent:hover {
  border-color: #00a79d;
  color: #00a79d;
}
.percent {
  font-size: 1.2rem;
  font-family: "Mitr", sans-serif !important;
  font-weight: 500 !important;
}
.box-step {
  border-right: solid;
  border-right-width: 1px;
  border-color: #dbdbdb;
}
.ps-fixed {
  position: fixed !important;
  width: 39% !important;
}
.subMenu {
  max-width: 410px;
}
</style>
